export default "__VITE_ASSET__CBqCDj_z__"